<nova-grid [data]="data$ | async" [args]="fetchArgs$ | async" [isLoading]="isLoading$ | async"
    [defaultFetchArgs]="defaultFetchArgs" [resizable]="false" [filterable]="false" [needToolbar]="false"
    [reorderable]="true"
    [pageable]="{buttonCount: 10, info: true, type: 'numeric', pageSizes: [25, 100, 150, 200, 250, 300, 350, 400, 450, 500], previousNext: true}"
    (dataNeeded)="load($event)">
    <nova-grid-column field="assignment" title=" " [groupTemplate]="categoryTemplate" [hidden]="true">
        <ng-template #categoryTemplate let-value="value">
            {{ getAssignmentLabel(value) }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="firstName" title="Name" [sortable]="true" [template]="nameTemplate" width="180">
        <ng-template #nameTemplate let-dataItem="dataItem">
            <a class="nova__link" href="/#/recruiting/candidates/{{ dataItem.id }}/new-profile/about" target="_blank">
                @if (showCandidateSearchModal && dataItem.middleName) {
                    {{ dataItem.firstName }} {{ dataItem.middleName }} {{ dataItem.lastName }}
                } @else {
                    {{ dataItem.firstName }} {{ dataItem.lastName }}
                }
            </a>
            @if (shouldHideContactInfo(dataItem)) {
            <div>Account Deactivated</div>
            }
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="email" title="Email" [sortable]="true" [template]="emailTemplate" width="180">
        <ng-template #emailTemplate let-dataItem="dataItem">
            @if (shouldHideContactInfo(dataItem)) {
            <span class="email-cell">Do not contact</span>
            } @else {
            <span class="nova__link email-cell" (click)="openEmailClient(dataItem.email)">
                {{ dataItem.email }}
            </span>
            }
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="phone" title="Phone" width="120" [template]="phoneTemplate">
        <ng-template #phoneTemplate let-dataItem="dataItem">
            @if (shouldHideContactInfo(dataItem)) {
            <span class="phone-cell">Do not contact</span>
            } @else {
            <span class="phone-cell">
                {{ dataItem.phone | phoneFormat }}
            </span>
            }
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="travelRecruiterFullName" title="Recruiter" [sortable]="true"
        [template]="travelRecruiterFullNameTemplate" width="180">
        <ng-template #travelRecruiterFullNameTemplate let-dataItem="dataItem">
            <span class="nova__link" (click)="openEmailClient(dataItem.travelRecruiterEmail)">
                {{ dataItem.travelRecruiterFullName }}
            </span>
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="professionAbbreviation" title="Prof." [sortable]="true" width="100">
    </nova-grid-column>
    <nova-grid-column field="specialtyText" title="Specialty" [sortable]="true" [template]="specialtyTextTemplate"
        width="100">
        <ng-template #specialtyTextTemplate let-dataItem="dataItem">
            @for (specText of dataItem.specialtyText?.split(';'); track specText) {
            <div>
                @if (specText?.trim()) {
                <div>
                    {{ specText }}
                </div>
                }
            </div>
            }
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="appDate" title="Registration" format="date" [sortable]="true" width="130"
        class="text-center">
    </nova-grid-column>
    <nova-grid-column field="noteDate" title="Last Note" format="date" [sortable]="true" width="80" class="text-center">
    </nova-grid-column>
    <nova-grid-column field="followup" title="Follow-Up" format="date" [sortable]="false" [template]="followupTemplate"
        width="80" class="text-center">
        <ng-template #followupTemplate let-dataItem="dataItem">
            @if (!dataItem.followupDate || dataItem.assignment !== candidateAssignment.Your) {
            <span class="followup-cell__none">
                none
            </span>
            } @else {
            <div class="followup-cell">
                <div class="followup-cell__priority">
                    @if (dataItem.followupPriority === 1) {
                    <mat-icon class="low-green">arrow_downward</mat-icon>
                    }
                    @if (dataItem.followupPriority === 2) {
                    <mat-icon class="med-yellow">arrow_upward</mat-icon>
                    }
                    @if (dataItem.followupPriority === 3) {
                    <mat-icon class="high-red">arrow_upward</mat-icon>
                    }
                </div>
                <div class="followup-cell__time">
                    {{ dataItem.followupDate | date : 'MM/dd/yy hh:mm a' }}
                </div>
            </div>
            }
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="sourceName" title="Source" [sortable]="true" width="100">
    </nova-grid-column>
</nova-grid>